import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont } from './chartConstants';

const AvgResponseTimeChart = ({ avgResponseTimeChart }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(avgResponseTimeChart) || avgResponseTimeChart.length === 0) return null;
        const hasData = avgResponseTimeChart.some(d => d.seconds !== null);
        if (!hasData) return null;
        const labels = avgResponseTimeChart.map((d, i) => {
            if (i === 0 || i === avgResponseTimeChart.length - 1 || i % 5 === 0) {
                const dt = new Date(d.date);
                return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            }
            return '';
        });
        return {
            labels,
            datasets: [{
                label: 'Avg Response Time',
                data:  avgResponseTimeChart.map(d => d.seconds !== null ? Math.round(d.seconds / 60) : null),
                fill:  true,
                backgroundColor: 'rgba(245, 158, 11, 0.15)',
                borderColor:     'rgba(245, 158, 11, 1)',
                borderWidth:     2,
                pointRadius:     3,
                pointHoverRadius: 5,
                pointBackgroundColor: 'rgba(245, 158, 11, 1)',
                pointBorderWidth: 0,
                lineTension: 0.35,
                spanGaps: false,
            }],
        };
    }, [avgResponseTimeChart]);

    const options = useMemo(() => {
        if (!avgResponseTimeChart) return {};
        return {
            maintainAspectRatio: false,
            legend: { display: false },
            tooltips: {
                mode: 'index', intersect: false,
                backgroundColor: '#1F2937',
                titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
                bodyFontFamily: baseFont,  bodyFontSize: 12,
                xPadding: 10, yPadding: 10,
                callbacks: {
                    title: (items) => {
                        const idx = items[0]?.index;
                        if (idx !== undefined && avgResponseTimeChart[idx]) {
                            const dt = new Date(avgResponseTimeChart[idx].date);
                            return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
                        }
                        return '';
                    },
                    label: (item, data) => {
                        const entry = avgResponseTimeChart[item.index];
                        if (!entry || entry.seconds === null) return ' No data';
                        return ` Avg: ${entry.label}`;
                    },
                },
            },
            scales: {
                xAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, maxRotation: 0, autoSkip: false } }],
                yAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? `${v}m` : null } }],
            },
        };
    }, [avgResponseTimeChart]);

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No response time data for the last 30 days</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Line data={chartData} options={options} /></div>;
};

export default AvgResponseTimeChart;
